'use strict'
define [], () ->
  (RentappService, Flash, Raven) ->
    restrict: "E"
    template: require("./supportMessage.jade")
    link: (scope, element, attrs) ->
      scope.$on 'submit-error', (event, args) ->
        Flash.create('danger', "Are you having trouble submitting your application? Text 832-264-6644 and we'll be happy to help", 15)
        element.focus()
      
        if args
          Raven.captureMessage(args.action, {
            level: 'info',
            extra: args		
          })



// WEBPACK FOOTER //
// ./directives/supportMessage/supportMessage.coffee